import { Image } from '@ccg/core';
import React$1, { useRef, useEffect } from 'react';
import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import { useSprings, animated } from 'react-spring';
import { useDrag } from 'react-use-gesture';
import StyledSlider from './Slider.style.js';

const getIndex = (input, total) => {
  if (input < 0) {
    return total;
  }

  if (input > total) {
    return 0;
  }

  return input;
};

const Slider = ({
  currentIndex,
  images,
  handleChange,
  overview,
  setIsOpen
}) => {
  const sliderRef = useRef(null); // Initialize slides with spring

  const [springProps, setSpringProps] = useSprings(images.length, index => ({
    offset: index
  })); // Bindings to set on the element

  const bind = useDrag(({
    down,
    movement: [xDelta],
    direction: [xDir],
    distance,
    cancel
  }) => {
    if (sliderRef && sliderRef.current && sliderRef.current.parentElement) {
      const {
        width
      } = sliderRef.current.parentElement.getBoundingClientRect();

      if (down && distance > width / 4) {
        if (cancel) cancel();
        handleChange(getIndex(currentIndex + (xDir > 0 ? -1 : 1), images.length - 1));
      }

      setSpringProps(index => ({
        offset: (down ? xDelta : 0) / width + (index - currentIndex)
      }));
    }
  }, {
    filterTaps: true
  });
  useEffect(() => {
    setSpringProps(index => ({
      offset: index - currentIndex
    }));
    handleChange(currentIndex);
  }, [currentIndex, setSpringProps]);
  return /*#__PURE__*/React$1.createElement(StyledSlider, {
    ref: sliderRef,
    overview: overview
  }, springProps.map(({
    offset
  }, index) => /*#__PURE__*/React$1.createElement(animated.div, _extends({}, bind(), {
    key: images[index].id,
    className: "slider__slide",
    style: {
      opacity: currentIndex === index ? '1' : '0',
      transform: offset.interpolate(offsetX => `translate3d(${offsetX * 100}%, 0, 0)`)
    }
  }), !overview && setIsOpen ? /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    className: "gallery__button",
    "aria-label": "Open Gallery",
    onClick: () => {
      setIsOpen(true);
    }
  }, /*#__PURE__*/React$1.createElement(Image, {
    src: images[index].src,
    alt: images[index].alt,
    lazy: true
  })) : /*#__PURE__*/React$1.createElement(Image, {
    src: images[index].src,
    alt: images[index].alt,
    lazy: true
  }))));
};

Slider.defaultProps = {
  overview: true,
  setIsOpen: null
};
Slider.propTypes = {
  overview: PropTypes$1.bool,
  setIsOpen: PropTypes$1.func,
  currentIndex: PropTypes$1.number.isRequired,
  handleChange: PropTypes$1.func.isRequired,
  images: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired
};

export default Slider;
